export class constants {
  static multiChoiceGridMaxButtonOptions = 3;
  static singleChoiceGridMaxButtonOptions = 3;
}
